import { render, staticRenderFns } from "./OutlineButton.vue?vue&type=template&id=1299a646"
import script from "./OutlineButton.vue?vue&type=script&lang=js"
export * from "./OutlineButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1299a646')) {
      api.createRecord('1299a646', component.options)
    } else {
      api.reload('1299a646', component.options)
    }
    module.hot.accept("./OutlineButton.vue?vue&type=template&id=1299a646", function () {
      api.rerender('1299a646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/OutlineButton.vue"
export default component.exports